// extracted by mini-css-extract-plugin
export default {"cls1":"AboutTheAuthorsSection-cls1__XJ","cls2":"AboutTheAuthorsSection-cls2__JI AboutTheAuthorsSection-cls1__XJ"};